export const checkEmailVerifiedAndApproved = async (body) => {
	try {
		fetch('https://us-central1-unity-61a0c.cloudfunctions.net/sendEmail',{
			method: 'POST', 
			mode: 'cors', 
			cache: 'no-cache', 
			credentials: 'same-origin',
			headers: {
			'Content-Type': 'application/json'
			},
			redirect: 'follow', 
			referrerPolicy: 'no-referrer', 
			body: JSON.stringify(body) 
		});

	} catch(error) {
		return error;
	}
};

export const setAWSLamda = async(data) => {
	try {
		return fetch('https://e8cdkz4lyi.execute-api.us-east-1.amazonaws.com/live/set',{
			method: 'POST',
			mode: 'cors',
			headers: {
				'Origin': '*',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data)
		},);
	} catch (error) {
		return error;
	};
};
